import React from 'react';
import { FiX } from 'react-icons/fi';
import '../ProductModal/ProductModal.css';

const STATUS_LABELS = {
  pending: 'pendiente',
  under_review: 'en revisión',
  approved: 'aprobada',
  rejected: 'rechazada'
};

const LEVEL_LABELS = {
  basic: 'Básica',
  professional: 'Profesional',
  academic: 'Académica',
  institutional: 'Institucional'
};

const VerificationRequestModal = ({
  open,
  onClose,
  latestRequest,
  form,
  setForm,
  onSubmit,
  submitting
}) => {
  if (!open) return null;

  const controlStyle = {
    width: '100%',
    padding: '0.6rem 0.75rem',
    borderRadius: 'var(--radius-md)',
    border: '1px solid var(--border)',
    background: 'var(--surface)',
    color: 'var(--text-primary)',
    outline: 'none'
  };

  return (
    <div className="product-modal-overlay" onClick={onClose}>
      <div
        className="product-modal"
        style={{ width: 'min(560px, 100%)' }}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="product-modal-close" onClick={onClose} aria-label="Cerrar">
          <FiX />
        </button>

        <div className="product-modal-content">
          <h3 className="product-modal-title" style={{ fontSize: '1.25rem' }}>
            Solicitar verificación
          </h3>

          {latestRequest && (
            <p className="product-modal-description">
              Estado actual:{' '}
              <strong>{STATUS_LABELS[latestRequest.status] || latestRequest.status}</strong>
              {latestRequest.requested_level
                ? ` (${LEVEL_LABELS[latestRequest.requested_level] || latestRequest.requested_level})`
                : ''}
            </p>
          )}

          <div style={{ display: 'grid', gap: 10 }}>
            <label style={{ display: 'grid', gap: 6 }}>
              <span style={{ color: 'var(--text-secondary)', fontWeight: 600, fontSize: '0.9rem' }}>
                Nivel
              </span>
              <select
                value={form.requested_level}
                onChange={(e) => setForm((p) => ({ ...p, requested_level: e.target.value }))}
                style={controlStyle}
              >
                <option value="basic">Básica</option>
                <option value="professional">Profesional</option>
                <option value="academic">Académica</option>
                <option value="institutional">Institucional</option>
              </select>
            </label>

            <label style={{ display: 'grid', gap: 6 }}>
              <span style={{ color: 'var(--text-secondary)', fontWeight: 600, fontSize: '0.9rem' }}>
                Notas (opcional)
              </span>
              <textarea
                rows={4}
                value={form.notes}
                onChange={(e) => setForm((p) => ({ ...p, notes: e.target.value }))}
                placeholder="Por qué quieres verificarte, institución, etc."
                style={{ ...controlStyle, resize: 'vertical' }}
              />
            </label>

            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button type="button" className="btn btn-ghost" onClick={onClose}>
                Cancelar
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={onSubmit}
                disabled={submitting}
              >
                {submitting ? 'Enviando…' : 'Enviar solicitud'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerificationRequestModal;
